import { AspectRatio, Box } from '@chakra-ui/react'
import { IProduct } from '@/entities/product/model/types'
import Image from 'next/image'
import React from 'react'
import Details from '../Details'
import { QuestionIcon } from '@/_assets/icon-components'

const CardHeader = ({
  product,
  totalDiscount,
}: {
  product: Partial<IProduct>
  totalDiscount: number
}) => {
  return (
    <Box bgColor='background' rounded='xl' overflow='hidden'>
      <Details totalDiscount={totalDiscount} product={product} />
      <AspectRatio position='relative' maxH='290px' ratio={1 / 1}>
        {product.image ? (
          <Image
            src={process.env.BASE_URL + product.image}
            alt={'blurry-pic'}
            style={{ objectFit: 'cover' }}
            fill
            sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
          />
        ) : (
          <Box opacity={0.5} color='text.muted'>
            <QuestionIcon color='currentColor' />
          </Box>
        )}
      </AspectRatio>
    </Box>
  )
}

export default CardHeader
